<template>
  <AuxiliaryList
    :items="surgeryIndicationMaterials"
    typeName="material"
    :deleteMutation="deleteItem"
    :saveMutation="save"
    :refreshList="refreshList"
  />
</template>

<script>
  import AuxiliaryList from "@/components/config/contact_len/auxiliary/list.vue";

  export default {
    name: "SurgeryMaterialConfig",
    components: {
      AuxiliaryList,
    },
    apollo: {
      surgeryIndicationMaterials: {
        query: require("@/graphql/surgery_indication/materials.gql"),
        pollInterval: 20000,
      },
    },
    methods: {
      deleteItem({ id }) {
        return this.apolloMutate({
          mutation: require("@/graphql/surgery_indication/delete_surgery_indication_material.gql"),
          variables: {
            surgeryIndicationMaterialId: id,
          },
        });
      },
      save({ id, name }) {
        return this.apolloMutate({
          mutation: require("@/graphql/surgery_indication/save_surgery_indication_material.gql"),
          variables: {
            surgeryIndicationMaterialId: id,
            name: name,
          },
        });
      },
      refreshList() {
        return this.$apollo.queries.surgeryIndicationMaterials.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
